import gql from "graphql-tag";

/**
 * @param {string} manufacturer
 * @param {string} model
 * @param {string} type
 * @param {string} condition
 * @param {string} location_id
 * @param {string} status
 * @param {string} user_id
 * @param {string} team_id
 */
export const INSERT_VENTILATOR = gql`
  mutation createNewVentilator(
    $serialNumber: String
    $manufacturer: String!
    $model: String!
    $type: String!
    $condition: String!
    $location_id: uuid!
    $status: String!
    $user_id: uuid!
    $team_id: uuid!
  ) {
    __typename
    insert_ventilator(
      objects: {
        serialNumber: $serialNumber
        condition: $condition
        location_id: $location_id
        manufacturer: $manufacturer
        model: $model
        status: $status
        team_id: $team_id
        type: $type
        user_id: $user_id
      }
    ) {
      returning {
        id
      }
    }
  }
`;
